import Polyglot from 'node-polyglot';

import * as helpers from './helpers.js';
import * as shopify from './shopify.js';

let languages = [
  'en',
  'de',
  'it',
  'pt',
  'fr',
  'es',
  'ru',
  'ja',
  'zh',
  'zh-tw',
];

function stripLanguageFromUrl(url) {
  for (let i = 0; i < languages.length; i++) {
    let lang = languages[i];
    url = url.replace(`/${lang}`, '')
  }
  return url;
}

function urlContainsLanguage(url) {
  for (let i = 0; i < languages.length; i++) {
    let lang = languages[i];
    if (url.includes(`/${lang}`)) return true;
  }
  return false;
}

let langLookup = {};
async function loadLanguages(lang, polyglot, source) {
  let enUrl = '';
  let langUrl = '';

  if (source === 'shopify') {
    enUrl = shopify.getShopifyAssetUrl('en.default.json');
    langUrl = shopify.getShopifyAssetUrl(lang + '.json');
  } else {
    enUrl = helpers.getWwwRootUrl() + `/i18n/en.json`;
    langUrl = helpers.getWwwRootUrl() + `/i18n/${lang}.json`;
  }

  if (lang !== 'en') {
    let results = {};
    [results.en, results.lang] = await Promise.all([
      fetch(enUrl),
      fetch(langUrl),
    ]);

    [langLookup.en, langLookup.lang] = await Promise.all([
      results.en.json(),
      results.lang.json(),
    ]);

    polyglot.en = new Polyglot({
      phrases: langLookup.en,
      locale: 'en',
      onMissingKey(key, options, locale) {
        console.log(`!! English key missing: ${key}'`)
        return key;
      },
    });
    polyglot.lang = new Polyglot({
      phrases: langLookup.lang,
      locale: lang,
      onMissingKey(key, options, locale) {
        console.log(`${key} not found for language '${locale}'`)
        return polyglot.en.t(key, options);
      },
    });
  } else {
    const result = await fetch(enUrl);
    langLookup.en = await result.json();

    polyglot.en = new Polyglot({
      phrases: langLookup.en,
      locale: lang,
      onMissingKey(key, options, locale) {
        console.log(`!! English key missing: ${key}'`)
        return key;
      },
    });
    polyglot.lang = polyglot.en;
  };
}

function getLanguageLookup() {
  return langLookup;
}

function translatePage(lang, polyglot, source, inPlaceEditMode) {
  let attributeName = 'data-i18n';
  if (source === 'shopify') {
    attributeName = 'data-i18n-shopify';
  }

  let elements = document.querySelectorAll(`[${attributeName}]`);
  elements.forEach((element) => {
    const key = element.getAttribute(attributeName);
    if (key === '') {
      console.log('i18n key is blank');
      return;
    }

    let translation = polyglot.lang.t(key);

    if (translation === '' && lang !== 'en') {
      console.log(`Translation is empty for key ${key}, language ${lang};`);
      translation = polyglot.en.t(key);
    }

    if (element.hasAttribute('value')) {
      element.setAttribute('value', translation);
    } else if (element.hasAttribute('placeholder')) {
      element.setAttribute('placeholder', translation);
    } else {
      element.innerHTML = translation;
      //`{{__phrase_${key}__}}`;
    }
  });
}

export {
  stripLanguageFromUrl,
  urlContainsLanguage,
  loadLanguages,
  translatePage,
  getLanguageLookup,
};
